<template>
  <el-breadcrumb separator=">">
    <el-breadcrumb-item
      v-for="(route, index) in routeList"
      v-if="route.name"
      :key="index"
    >
      <a
        href="javascript:;"
        @click="change(index)"
      >{{ route.name }}</a>
    </el-breadcrumb-item>
  </el-breadcrumb>
</template>
<script>
  export default {
    name: 'BreadCrumb',
    props: ['routeList'],
    methods: {
      change (index) {
        if (!index) return
        let urls = this.$route.fullPath.split('/')
        urls.shift()
        let path = ''
        urls.forEach((item, i) => {
          if (i <= index) {
            path += '/' + item
          }
        })
        this.$router.push(path)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/modules/history/bread-crumb.vue